import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import LoadingOverlay from "../helper-components/overlay-loading";
import { useFormikContext } from "formik";
import ItemsSearchAddFeild from "../forms/items-search-add-field";
import {
  pincodeListAction,
  productListAction,
  storesItemAction,
} from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import ItemsInputField from "../forms/items-input-field";
import { useNavigate } from "react-router-dom";
import { truncateString } from "../helper-components/helper-function";

export default function BillingOtherStores({ open, setOpen, selectedItem }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const rows = (data?.data ?? []).map((item) => ({
        value: item.item_id,
        label: item.item_name,
      }));
      setLocalData(data.data);
      callback(rows);
    };

    const onError = () => {};

    if (inputValue?.length > 0) {
      dispatch(
        productListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  useEffect(() => {
    if (open) {
      setFieldValue(`otherStores.item_id`, selectedItem?.itemid);
      setFieldValue(`otherStores.item_name`, selectedItem?.item_name);
    }
  }, [open]);

  // Same as General Info: a 6-digit pincode fills State, District and City
  const clearLocation = () => {
    setFieldValue("otherStores.state", "");
    setFieldValue("otherStores.district", "");
    setFieldValue("otherStores.city", "");
  };
  const fetchAddressFn = (pincode) => {
    if (pincode?.length !== 6) {
      clearLocation();
      return;
    }
    dispatch(
      pincodeListAction(
        pincode,
        (response) => {
          if (response?.[0]?.Status === "Error") {
            clearLocation();
            return;
          }
          const firstPostOffice = response?.[0]?.PostOffice?.[0];
          setFieldValue("otherStores.state", firstPostOffice?.State ?? "");
          setFieldValue("otherStores.district", firstPostOffice?.District ?? "");
          setFieldValue("otherStores.city", firstPostOffice?.Division ?? "");
        },
        clearLocation
      )
    );
  };
  const storesItemDebounceRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    if (storesItemDebounceRef.current) {
      clearTimeout(storesItemDebounceRef.current);
    }
    storesItemDebounceRef.current = setTimeout(() => {
      dispatch(
        storesItemAction(
          {
            item_id: values?.otherStores?.item_id || selectedItem?.itemid || "",
            store_code: values?.tempRowData?.store_search || "",
            shop_town_or_village: values?.otherStores?.district || "",
            shop_city: values?.otherStores?.city || "",
          },
          onSuccess,
          onError
        )
      );
    }, 300);
    return () => {
      if (storesItemDebounceRef.current) {
        clearTimeout(storesItemDebounceRef.current);
      }
    };
  }, [
    open,
    values?.otherStores?.item_id,
    values?.otherStores?.district,
    values?.otherStores?.city,
    values?.tempRowData?.store_search,
  ]);

  const onSuccess = (data) => {
    setFieldValue(`otherStores.items`, data?.data);
  };
  const onError = (data) => {
    setFieldValue(`otherStores.items`, []);
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[80%] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div
                    style={{
                      maxHeight: "32px",
                      color: "var(--slide-panel-h-fg)",
                      fontSize: "var(--slide-panel-h-fs)",
                      fontWeight: "var(--slide-panel-h-fw)",
                    }}
                    className="min-w-[75%] "
                  >
                    Other Stores
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>
                <div
                  className="px-3 "
                  style={{
                    maxHeight: `calc(100% - 115px)`,
                    minHeight: `calc(100% - 115px)`,
                    height: `calc(100% - 115px)`,
                  }}
                >
                  <div className="flex flex-wrap items-center justify-between gap-x-3 h-[5.5rem]">
                    <div className="w-[20%]">
                      <ItemsSearchAddFeild
                        useDefaultStyles={true}
                        defaultOptions={values?.data?.map((item) => ({
                          label: item.item_name,
                          value: item.item_id,
                        }))}
                        label={"Select Or Search product"}
                        isDisabled={false}
                        isLabelReq={true}
                        menuPlacement="auto"
                        optionPadding={0}
                        menuWidth="45rem"
                        errorClass="hidden"
                        isRequired={false}
                        value={
                          values?.otherStores?.item_id
                            ? {
                                label: values.otherStores.item_name,
                                value: values.otherStores.item_id,
                              }
                            : null
                        }
                        name={`otherStores.item_name`}
                        field={"item_name"}
                        defaultSelectClass=""
                        placeholder={"Select Or Search product"}
                        fetchData={fetchData}
                        onChange={async (selectedOption) => {
                          console.log(selectedOption, "gdsfsfsdfdsfsfs");
                          if (!selectedOption) return;

                          const foundItem = localData?.find(
                            (item) => item.item_id === selectedOption.value
                          );

                          setFieldValue(
                            "otherStores.item_id",
                            selectedOption.value
                          );
                          setFieldValue(
                            "otherStores.item_name",
                            selectedOption.label
                          );
                        }}
                      />
                    </div>
                    <div className="w-[14%]">
                      <ItemsInputField
                        name={`otherStores.pincode`}
                        label="Pincode"
                        isLabelReq={true}
                        placeholder="Enter Pincode"
                        maxLength={6}
                        onChange={(e) => fetchAddressFn(e?.target?.value)}
                      />
                    </div>
                    <div className="w-[14%]">
                      <ItemsInputField
                        name={`otherStores.state`}
                        label="State"
                        isLabelReq={true}
                        placeholder="State"
                        disabled={true}
                        allowAll={true}
                      />
                    </div>
                    <div className="w-[14%]">
                      <ItemsInputField
                        name={`otherStores.district`}
                        label="District"
                        isLabelReq={true}
                        placeholder="District"
                        disabled={true}
                        allowAll={true}
                      />
                    </div>
                    <div className="w-[14%]">
                      <ItemsInputField
                        name={`otherStores.city`}
                        label="City"
                        isLabelReq={true}
                        placeholder="City"
                        disabled={true}
                        allowAll={true}
                      />
                    </div>
                    <div className="w-[18%]">
                      <ItemsInputField
                        name={`tempRowData.store_search`}
                        label="Search Store"
                        isLabelReq={true}
                        placeholder="Search Store name or code"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      maxHeight: `calc(100% - 6rem)`,
                      minHeight: `5rem`,
                    }}
                    className="tab-container rounded-[8px] "
                  >
                    <table className="w-full border-collapse mt-0">
                      <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                        <tr className="relative h-[50px] rounded-lg">
                          {heading
                            .filter((col) => col.enabled !== false)
                            .map((col, idx) => (
                              <th
                                style={{ minWidth: `${col?.minWidth}px` }}
                                key={idx}
                                className="px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]"
                              >
                                <div
                                  className="flex items-center gap-2 w-full text-wrap"
                                  style={{
                                    justifyContent:
                                      col?.alignment === "right"
                                        ? "flex-end"
                                        : col?.alignment === "center"
                                        ? "center"
                                        : "flex-start",
                                  }}
                                >
                                  {col?.label}
                                </div>
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {values.otherStores.items?.length > 0 ? (
                          <>
                            {" "}
                            {values.otherStores.items
                              ?.map((batch, index) => (
                                <tr
                                  key={batch.store_code || index}
                                  className={`cursor-pointer transition-all  ${
                                    index % 2 === 0
                                      ? " bg-[var(--create-table-row-alt-bg)]"
                                      : " bg-[var(--create-table-row-bg)]"
                                  }   h-[48px]`}
                                >
                                  {heading
                                    .filter((col) => col.enabled !== false)
                                    .map((col, colIndex) => (
                                      <td
                                        style={{
                                          minWidth: `${col?.minWidth}px`,
                                          textAlign: col?.alignment, // Keep textAlign for normal text cells
                                        }}
                                        key={colIndex}
                                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)]  whitespace-nowrap cursor-pointer"
                                      >
                                        {col?.value === "action" ? (
                                          <AddButton
                                            prefixIcon={false}
                                            text={"Transfer Request"}
                                            className="flex items-center px-[15px] h-[35px] whitespace-nowrap rounded-md gap-[8px]
                    bg-[var(--primary-button-bg-color)] cursor-pointer
                    text-[var(--primary-button-fg-color)]
                    border border-[var(--primary-button-bg-color)]
                    hover:bg-[var(--primary-button-hover-color)]
                    text-[length:var(--primary-button-font-size)] 
                    font-[var(--primary-button-font-weight)]"
                                            type="button"
                                            onclkFn={() => {
                                              navigate("/add-stock-transfer");
                                            }}
                                          />
                                        ) : (
                                          truncateString(
                                            batch[col.value] || "",
                                            100
                                          ) ?? "--"
                                        )}
                                      </td>
                                    ))}
                                </tr>
                              ))}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                heading?.filter((h) => h?.enabled !== false)
                                  .length
                              }
                              className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                            >
                              No stores found for the selected criteria.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="flex justify-between h-[50px] items-center px-3">
                  <AddButton
                    prefixIcon={false}
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    text={
                      <span>
                        Cancel <span className="opacity-50">(C)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                <LoadingOverlay />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const heading = [
  { label: "Store Code", value: "store_code" },
  { label: "Store Address", value: "shop_address" },
  { label: "Store Type", value: "store_type" },
  { label: "Available Qty", value: "total_quantity" },
  { label: "No. of Batches", value: "batch_count" },
  { label: "Action", value: "action" },
];
